import React from 'react';
import { Reveal } from './Reveal';

interface SectionHeaderProps {
  label: string;
  /** Supports <em> for italic accent — pass as JSX or string */
  title: React.ReactNode;
}

/**
 * Consistent label + title header used at the top of every section.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({ label, title }) => (
  <Reveal>
    <div className="sec-header">
      <div className="sec-label">{label}</div>
      <h2 className="sec-title">{title}</h2>
    </div>
  </Reveal>
);
